import makeSlice from '@web/slices/receiverInfo/sliceMaker'

const slice = makeSlice()

export default slice.reducer
